import './test-button.scss';

interface Props {
    children?: any;
}

export const TestButton = ({ children }: Props) => {
    return <button className="mainbutton">{children}</button>;
}